import React from 'react';
import './Refunpolicy.css';
import Header from './Header';
import Footer from './Footer';

const RefundPolicy = () => {
    return (
        <div>
            <Header />
            <div className="nd-refund-page">
                <div className="nd-refund-container container">
                    <div className="nd-refund-hero">
                        <div className="nd-refund-badge">Payment & Subscription Policy</div>
                        <h1 className="nd-refund-title">Refund Policy</h1>
                    </div>

                    <div className="nd-refund-lead-card">
                        <p>Thank you for choosing N D Connect, a product of N D Techland Private Limited. We are committed to providing a seamless and efficient service. Please carefully read our Refund Policy outlined below.</p>
                    </div>

                    <div className="nd-refund-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-refund-card">
                            <div className="nd-refund-card-header">
                                <span className="nd-refund-num">01</span>
                                <h5><strong>No Refunds Policy</strong></h5>
                            </div>
                            <div className="nd-refund-card-body">
                                <p>Once your account has been activated after successful payment and the signing of the Memorandum of Understanding (MOU), you cannot cancel your subscription, and no refunds will be issued. By proceeding with the payment and activation of your N D Connect account, you acknowledge and agree to this policy.</p>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-refund-card">
                            <div className="nd-refund-card-header">
                                <span className="nd-refund-num">02</span>
                                <h5><strong>Subscription Activation</strong></h5>
                            </div>
                            <div className="nd-refund-card-body">
                                <p>Once payment is processed and your account is activated, your subscription begins, and you will have full access to all features and services of N D Connect as agreed in the MOU. The service provided is non-refundable and non-cancellable once your account is live.</p>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-refund-card">
                            <div className="nd-refund-card-header">
                                <span className="nd-refund-num">03</span>
                                <h5><strong>Exceptions</strong></h5>
                            </div>
                            <div className="nd-refund-card-body">
                                <p>In exceptional circumstances, if there is a technical issue on our end that prevents you from accessing or using the service, we may evaluate requests for refunds or alternative resolutions on a case-by-case basis.</p>
                            </div>
                        </div>

                        {/* Contact & Inquiries Card */}
                        <div className="nd-refund-card nd-refund-contact-card">
                            <div className="nd-refund-card-header">
                                <span className="nd-refund-num">📞</span>
                                <h5><strong>Inquiries & Support</strong></h5>
                            </div>
                            <div className="nd-refund-card-body">
                                <p>For any inquiries regarding this policy, please contact us at <a href="mailto:info@ndtechland.com">info@ndtechland.com</a> or call +91 8826302378. We are here to assist you!</p>

                                <div className="nd-refund-contact-grid">
                                    <div className="nd-refund-contact-item">
                                        <span className="nd-refund-contact-label">Email Support</span>
                                        <span className="nd-refund-contact-val"><a href="mailto:info@ndtechland.com">info@ndtechland.com</a></span>
                                    </div>
                                    <div className="nd-refund-contact-item">
                                        <span className="nd-refund-contact-label">Direct Line</span>
                                        <span className="nd-refund-contact-val">+91 8826302378</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default RefundPolicy;
